import Badge from '@codegouvfr/react-dsfr/Badge';
import Button from '@codegouvfr/react-dsfr/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InformationProps, InformationSubtitle } from '../types/information-props.type';


export const DashboardInformationCard = (information: InformationProps) => {
  const navigate = useNavigate();

  return (
    <div className={'fr-card w-full'}>
      <div className={'flex flex-col px-8 py-4 gap-6'}>
        <div className={'flex items-center gap-4'}>
          {information.picto}
          <div className={'flex-col'}>
            <h6 style={{ marginBottom: '8px' }}>{information.title}</h6>
            <Badge noIcon={information.badgeNoIcon} severity={information.badgeSeverity}>
              {information.statutText}
            </Badge>
          </div>
        </div>
        <div className={'flex flex-wrap gap-12'}>
          {information.subSection.map((el: InformationSubtitle, index) => (
            <div key={`${el.title}-${index}`} className={'flex flex-col'}>
              <span className={'text-(--text-label-blue-france)'}>{el.title}</span>
              <span className={'text-(--text-title-grey)'}>{el.text}</span>
            </div>
          ))}
        </div>
        <div className={'border-0 border-t-1 border-[#eee] flex justify-end'}>
          <div>
            <Button
              onClick={() => navigate(information.linkUrl)}
              className="hover:border-none"
              style={{ color: 'var(--text-mention-grey)' }}
              priority="tertiary no outline"
              iconId="fr-icon-arrow-right-line"
            ><span className={'text-sm'}>{information.linkText}</span></Button>
          </div>
        </div>
      </div>
    </div>
  );
};